
const digest = '452205b1ffa411021a523956f7dc7e1269eb16f6b6c295290ba87456550cf263';
const classes = {"buttons":"_buttons_1ecci_1"};
const css = `._buttons_1ecci_1 {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  